import { api } from 'api/api';
import { CadastroFiscalNome, OpcaoFiscal, RegistroFiscal } from 'model/fiscal/ParametrosFiscais';

export default class ParametrosFiscaisService {
    async listar(cadastro: CadastroFiscalNome): Promise<RegistroFiscal[]> {
        return (await api.get<RegistroFiscal[]>(`/fiscal/${cadastro}/getAll`)).data;
    }
    async salvar(cadastro: CadastroFiscalNome, registro: RegistroFiscal): Promise<RegistroFiscal> {
        return registro.id
            ? (await api.put<RegistroFiscal>(`/fiscal/${cadastro}/editar`, registro)).data
            : (await api.post<RegistroFiscal>(`/fiscal/${cadastro}/incluir`, registro)).data;
    }
    async excluir(cadastro: CadastroFiscalNome, id: number): Promise<void> {
        await api.delete(`/fiscal/${cadastro}/excluir/${id}`);
    }
    async opcoes(referencia: string): Promise<OpcaoFiscal[]> {
        return (await api.get<OpcaoFiscal[]>(`/fiscal/parametros/opcoes/${referencia}`)).data;
    }
}
